import type { Locale } from '@/i18n/config'

export type NotFoundCopy = {
  title: string
  subtitle: string
  home: string
  quickTitle: string
}

export type NotFoundLink = { to: string; label: string }

export type NotFoundView = {
  locale: Locale
  copy: NotFoundCopy
  links: NotFoundLink[]
}

const COPY: Record<Locale, NotFoundCopy> = {
  fr: {
    title: 'Page introuvable',
    subtitle: "Ce lien n'existe plus ou a été déplacé.",
    home: "Retour à l'accueil",
    quickTitle: 'Ou reprenez ici :',
  },
  en: {
    title: 'Page not found',
    subtitle: 'This link no longer exists or has moved.',
    home: 'Back to home',
    quickTitle: 'Or pick up here:',
  },
}

// Ordre = ordre d'affichage. `to` sont des routes typées du routeTree ; le
// composant fournit `params={{ locale }}`.
const LINKS: Record<Locale, NotFoundLink[]> = {
  fr: [
    { to: '/$locale/solutions/people-security', label: 'Solutions' },
    { to: '/$locale/blog', label: 'Blog' },
    { to: '/$locale/about', label: 'À propos' },
  ],
  en: [
    { to: '/$locale/solutions/people-security', label: 'Solutions' },
    { to: '/$locale/blog', label: 'Blog' },
    { to: '/$locale/about', label: 'About' },
  ],
}

export function resolveNotFoundForLocale(locale: Locale): NotFoundView {
  return { locale, copy: COPY[locale], links: LINKS[locale] }
}
